import { useState } from 'react';
import {addPerformedActions} from "../../services/Technician/ticketsService";

export const useAddPerformedActions = () => {
    const [savingActions, setSavingActions] = useState(false);

    const addActions = async (performedActions: any, ticketUniqueCode: string) => {
        setSavingActions(true);
        try {
            await addPerformedActions(performedActions, ticketUniqueCode);
        } catch (error: any) {
            throw error;
        } finally {
            setTimeout(() => setSavingActions(false), 600);
        }
    };

    return { addActions, savingActions };
};
